export const TEAM_ABBREVIATIONS: Record<string, string> = {
  "Manchester United": "Man Utd",
  "Tottenham Hotspur": "Spurs",
  "West Ham United": "West Ham",
  "Crystal Palace": "C. Palace",
}; 